import { render, staticRenderFns } from "./senders-list-page.vue?vue&type=template&id=0087289c&"
import script from "./senders-list-page.vue?vue&type=script&lang=js&"
export * from "./senders-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports